import { http } from './http';

//Details
export const getKyu101 = () => {
  return http.get<any>(`kyu_101`);
};
